import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// Lazy-load por rota (§8.1 — guardrail Vite): cada tela puxa só o próprio chunk.
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { layout: 'bare' },
  },
  {
    path: '/acesso-seguro',
    name: 'two-factor',
    component: () => import('@/pages/TwoFactorPage.vue'),
    meta: { layout: 'bare' },
  },
  { path: '/2fa', redirect: { name: 'two-factor' } },
  { path: '/', redirect: { name: 'chamado-quadro' } },
  {
    path: '/chamado',
    name: 'chamado',
    component: () => import('@/pages/TicketsWorkspacePage.vue'),
    redirect: { name: 'chamado-quadro' },
    children: [
      {
        path: 'lista',
        name: 'inbox',
        component: () => import('@/pages/InboxPage.vue'),
        props: { embedded: true },
      },
      {
        path: 'quadro',
        name: 'chamado-quadro',
        component: () => import('@/pages/KanbanPage.vue'),
        props: { embedded: true },
      },
      {
        path: '/tickets/:id',
        name: 'ticket',
        component: () => import('@/pages/TicketModalPage.vue'),
        props: true,
      },
    ],
  },
  { path: '/kanban', redirect: { name: 'chamado-quadro' } },
  {
    path: '/implantation',
    name: 'implantation',
    component: () => import('@/pages/ImplantationPage.vue'),
    meta: { roles: ['admin'] },
  },
  { path: '/management', name: 'management', component: () => import('@/pages/admin/ManagementPage.vue') },
  { path: '/accounts', name: 'accounts', component: () => import('@/pages/AccountsPage.vue') },
  { path: '/admin/agents', name: 'agents', component: () => import('@/pages/admin/AgentsPage.vue') },
  { path: '/admin/teams', name: 'teams', component: () => import('@/pages/admin/TeamsPage.vue') },
  { path: '/admin/sla', name: 'sla', component: () => import('@/pages/admin/SlaPage.vue') },
  { path: '/reports', name: 'reports', component: () => import('@/pages/ReportsPage.vue') },
  { path: '/queue', name: 'queue', component: () => import('@/pages/QueuePage.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Guard: resolve o usuário atual 1x no boot; protege rotas autenticadas e
// canaliza a sessão meio-autenticada (senha ok, TOTP pendente) pro acesso seguro.
router.beforeEach(async to => {
  const auth = useAuthStore()
  if (!auth.ready) await auth.fetchMe()

  const publicRoutes = ['login', 'two-factor']

  // TOTP pendente: prende em /acesso-seguro até concluir o desafio.
  if (auth.otpPending) {
    return to.name === 'two-factor' ? true : { name: 'two-factor' }
  }
  // Sem desafio em andamento: ninguém fica em /acesso-seguro.
  if (to.name === 'two-factor') {
    return auth.isAuthenticated ? { name: 'inbox' } : { name: 'login' }
  }

  if (!publicRoutes.includes(to.name) && !auth.isAuthenticated) {
    return { name: 'login' }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'inbox' }
  }
  if (to.meta.roles && !to.meta.roles.includes(auth.profile)) {
    return { name: 'inbox' }
  }
  return true
})

export default router
